<template>
    <div :class="['input-wrapper', 'form-input-phone-number', { 'input-wrapper-mb-2x': marginBottomDouble }]">
        <div class="form-input-phone-number-wrapper">
            <div :class="['form-input-select', { 'input-has-full-border': fullBorder, 'is-required': required, 'input-error-border': hasError, 'disabled': phoneCountryDisabled }]">
                <select v-if="countryCodes.length > 0" id="phone_country" name="phone_country">
                    <option
                        v-for="countryCode in countryCodes"
                        :key="countryCode.locale"
                        :value="countryCode.country"
                        :selected="countryCode.locale === dataLocale || countryCode.country === dataLocale"
                        class="country-option"
                        :data-title="__(countryCode.title)"
                    >
                        <div class="content">
                            <img :src="`/imgs/flags/${countryCode.locale}.svg`" alt="">
                            <div>{{ countryCode.code }}</div>
                        </div>
                    </option>
                </select>
            </div>

            <div :class="['form-input-text', { 'input-has-full-border': fullBorder, 'is-required': required }]">
                <label v-if="label" :for="name" :class="{ 'float-label-active': isFloatLabelActive, 'is-float-label': !withoutFloatLabel }">{{ label }}<span v-if="required">*</span></label>
                <input
                    :id="name"
                    v-model="inputValue"
                    type="tel"
                    :class="{
                        'required-input': required,
                        'input-error-border': hasError,
                        'full-border': fullBorder,
                        'basic-border': !fullBorder
                    }"
                    :name="name"
                    :placeholder="label"
                    :required="required"
                    @focus="activateFloatLabel"
                    @blur="deactivateFloatLabel"
                />
            </div>
        </div>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            required: false,
            default: null
        },

        value: {
            type: String,
            required: false,
            default: ''
        },

        phoneCountry: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        label: {
            type: String,
            required: false,
            default: null
        },

        required: {
            type: Boolean,
            required: false,
            default: false
        },

        fullBorder: {
            type: Boolean,
            required: false,
            default: false
        },

        note: {
            type: String,
            required: false,
            default: null
        },

        marginBottomDouble: {
            type: Boolean,
            required: false,
            default: false
        },

        withoutFloatLabel: {
            type: Boolean,
            required: false,
            default: false
        },

        phoneCountryDisabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            dataLocale: this.phoneCountry,
            countryCodes: [
                {country:"DE",code:"+49",title:"Germany",locale:"de"}
            ],
            countryCodesErrors: null,
            inputValue: this.value,
            hasError: false,
            isFloatLabelActive: false
        }
    },

    watch: {
        inputValue: {
            immediate: true,
            handler(value) {
                if (value.length > 0) {
                    this.hasError = false
                    this.inputValue = value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1')
                    this.isFloatLabelActive = true
                }
            }
        },

        errors: {
            immediate: true,
            handler(errors) {
                if (errors === null || errors === undefined || errors.length === 0) {
                    this.hasError = false
                } else {
                    this.hasError = true
                }
            }
        }
    },

    mounted() {
        if (this.phoneCountry === '') {
            this.dataLocale = this.locale
        }

        this.$nextTick(function() {
            $(this.$el).find('select').selectpicker()
        })

        axios
            .get('/api/phone-country-codes')
            .then((res) => {
                this.countryCodes = res.data.data

                this.$nextTick(function() {
                    $(this.$el).find('select').selectpicker('refresh')
                })
            })
            .catch((e) => {
                this.countryCodesErrors = e.response.data.errors
            })
    },

    methods: {
        activateFloatLabel() {
            this.isFloatLabelActive = true
        },

        deactivateFloatLabel() {
            if(this.inputValue.length === 0) {
                this.isFloatLabelActive = false
            }
        }
    }
}
</script>
